import React from 'react';
import { Icon } from 'antd';
import Toggler from '../../../../shared/ui/Toggler';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import {
  detailsPageModeMap,
  searchParamKeys,
  searchParamSelectors,
  viewMap,
} from '../../../../shared/configs/searchParams';
import { ReactComponent as CalendarIcon } from '../../../../../../resource/Calendar31Icon.svg';
import { ReactComponent as ListIcon } from '../../../../../../resource/ToDoListIcon.svg';
import styles from './index.module.scss';

const { view: viewKey, detailsPageMode: pageModeKey } = searchParamKeys;

const registerModes = new Set([
  detailsPageModeMap.registration,
  detailsPageModeMap.reRegistration,
]);

const items = [
  {
    value: viewMap.calendar,
    label: <Icon component={CalendarIcon} className={styles.icon} />,
    tooltipTitle: 'Календарь',
  },
  {
    value: viewMap.list,
    label: <Icon component={ListIcon} className={styles.icon} />,
    tooltipTitle: 'Список помещений',
  },
];

const ToggleView = () => {
  const view = useSearchParamsSelector(searchParamSelectors[viewKey]);
  const pageMode = useSearchParamsSelector(searchParamSelectors[pageModeKey]);

  const { setParams } = useSearchParamsMethods();

  const handleChange = (value, e) => {
    e.stopPropagation();
    setParams({
      [viewKey]: value,
    });
  };

  return (
    <Toggler
      items={items}
      value={view}
      btnCN={styles.button}
      onChange={handleChange}
      disabled={registerModes.has(pageMode)}
    />
  );
};

export default ToggleView;
